// The page a Nova run was started from, sent with the run so it can be told apart in analytics.
// The server accepts only these values and treats anything else as absent, so a surface that is
// not one of them is better left off than invented here.
export const NOVA_RUN_SURFACE = {
	TASK_LIST: 'Task List',
	TASK_BOARD: 'Task Board',
	MY_WORK_BOARD: 'My Work Board',
	SPRINTS: 'Sprints',
	SPRINT_BACKLOG: 'Sprint Backlog',
	MY_TASKS: 'My Tasks',
	TASK_MODAL: 'Task Modal',
} as const;

export type NovaRunSurface = (typeof NOVA_RUN_SURFACE)[keyof typeof NOVA_RUN_SURFACE];
